export default {
    daySelector: {
        day: 'Day',
    },
}
